import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DownloadInvoices } from '../../../../models/invoices-reports.model';

@Component({
  selector: 'app-federal-government',
  templateUrl: './federal-government.component.html',
  styleUrls: ['./federal-government.component.css']
})
export class InvoicesFederalGovernmentComponent implements OnInit, OnDestroy {
  warrant_auth_code: string = 'JA';
  janinvoicesrptform: FormGroup;
  allSub: Subscription[] = [];
  errorMessage: string = '';
  downloadMessage: string = '';
  loading: boolean = false;
  userName: string = '';
  screenCode: string = '';
  isSubmit: boolean = false;
  accOffCodes = [];
  exportFileTypes = [];
  downloadInvoices: DownloadInvoices = new DownloadInvoices();

  constructor(private userService: UserService,
    private reportService: ReportService,
    public snackBar: MatSnackBar) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.janinvoicesrptform = new FormGroup({
      janInvoiceDate: new FormControl({ value: '', disabled: false }, [Validators.required]),
      airasiaref: new FormControl({ value: '', disabled: false }),
      janInvoiceNo : new FormControl({ value: '', disabled: false }),
      accoffcode: new FormControl({ value: '', disabled: false }, [Validators.required]),
      janBookingDateFrom: new FormControl({ value: '', disabled: false }, [Validators.required]),
      janBookingDateTo: new FormControl({ value: '', disabled: false }, [Validators.required]),
      exportfiletype: new FormControl({ value: '', disabled: false }, [Validators.required])
    });

    this.loading = true;
    let init_sub = this.reportService.getInitFedInvoices()
      .subscribe(
        (value) => {
          this.loading = false;
          this.accOffCodes = value.body['accountOffices'];
          this.exportFileTypes = value.body['exportFileTypeDT'];

          this.janinvoicesrptform.setValue({
            janInvoiceDate: new Date(),
            airasiaref: '',
            janInvoiceNo: '',
            accoffcode: value.body['accountOffices'][0].Acc_Off_Code,
            janBookingDateFrom: new Date(),
            janBookingDateTo: new Date(),
            exportfiletype: value.body['exportFileTypeDT'][0].VALUE
          });
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  onSubmit(form: FormGroup) {
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    this.downloadInvoices.AirAsiaRef = form.get('airasiaref').value;
    this.downloadInvoices.AccountOfficeCode = form.get('accoffcode').value;
    this.downloadInvoices.BookingDateFrom = form.get('janBookingDateFrom').value;
    this.downloadInvoices.BookingDateTo = form.get('janBookingDateTo').value;
    this.downloadInvoices.InvoiceDate = form.get('janInvoiceDate').value;
    this.downloadInvoices.ExportFileType = form.get('exportfiletype').value;
    this.downloadInvoices.InvoiceNumber = form.get('janInvoiceNo').value;

    let update_sub = this.reportService.downloadFedInvoices(this.downloadInvoices)
      .subscribe(
        (value) => {
          if (value.status === 204) {

          } else if (value.status === 200) {
            if (this.downloadInvoices.ExportFileType === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'JAN Invoice.xls');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            } else if (this.downloadInvoices.ExportFileType === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'JAN Invoice.pdf');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            }
          } else {
            this.isSubmit = false;
            this.openSnackBar('Error downloading invoice.', '');
          }
        },
        (error) => {
          this.isSubmit = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(update_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
